import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST, APIImpl } from '../../api';
import { GetPlaylistRequest } from './getplaylistrequest';

export class GetPlaylistAPI extends APIImpl<GetPlaylistRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/get-play-list
        return "get-play-list";
    }

    getRequestData()
    {
        return "toneCode="+ this.getRequest().getGetPlaylistRequest().getToneCode()+"&"+
               "type="+ this.getRequest().getGetPlaylistRequest().getType()+"&"+
               "isAll="+ this.getRequest().getGetPlaylistRequest().getIsAll()+"&"+
               "contentTypeId="+ this.getRequest().getGetPlaylistRequest().getContentTypeId()+"&"+
               "clientTxnId=329644640"+"&"+
               "language="+ this.getRequest().getGetPlaylistRequest().getLanguage()+"&"+
               "clientSessionId=998671752";
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/banner/getplaylist/getplaylistapi.tsx